{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.126543,
          0.006953,
          243.792325
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.175228,
          0.006346,
          236.981786
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.175228,
          0.006346,
          236.981786
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.269413,
          0.01036,
          242.083865
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.126543,
          0.006953,
          243.792325
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.970151,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.863097,
          0.007776,
          228.868893
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.645222,
          0.009348,
          225.150438
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.126543,
          0.006953,
          243.792325
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.864091,
          0.092143,
          223.595164
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.348204,
          0.010712,
          236.894097
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.269413,
          0.01036,
          242.083865
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.645222,
          0.009348,
          225.150438
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.719588,
          0.160232,
          241.934243
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.864091,
          0.092143,
          223.595164
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.190403,
          0.080719,
          260.682766
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.173455,
          0.059022,
          142.495345
        ],
        "alpha": 1,
        "hex": "#001600"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.775209,
          0.103098,
          142.532525
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.40526,
          0.136911,
          142.712023
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.604784,
          0.163709,
          142.769697
        ],
        "alpha": 1,
        "hex": "#399936"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.18011,
          0.062518,
          35.437897
        ],
        "alpha": 1,
        "hex": "#270400"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.791422,
          0.092884,
          44.093664
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.431173,
          0.130695,
          40.89405
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.634409,
          0.150779,
          43.925238
        ],
        "alpha": 1,
        "hex": "#d36734"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.161611,
          0.065248,
          23.141473
        ],
        "alpha": 1,
        "hex": "#230002"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.75077,
          0.106785,
          18.43901
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.374388,
          0.145685,
          19.336218
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.565284,
          0.170522,
          18.2478
        ],
        "alpha": 1,
        "hex": "#c63f4e"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.137795,
          0.047857,
          264.580497
        ],
        "alpha": 1,
        "hex": "#02071c"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.676764,
          0.068234,
          261.470834
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.331327,
          0.095363,
          262.195822
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.508435,
          0.109592,
          262.050185
        ],
        "alpha": 1,
        "hex": "#4264a4"
      }
    }
  }
}
